import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";
import { NAV_LINKS, COMPANY_MENU, COMPANY } from "../mock";

export default function Footer() {
  return (
    <footer className="relative bg-[#080808] border-t border-white/10">
      <div className="dot-grid absolute inset-0 opacity-40 pointer-events-none" />
      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="grid h-10 w-10 place-items-center border-2 border-[#c3e63c] shrink-0">
                <span className="h-[18px] w-[18px] bg-[#c3e63c]" />
              </span>
              <span className="font-display text-lg md:text-2xl font-bold tracking-tight uppercase leading-none">
                <span className="text-white">Garry Industries</span>
                <span className="text-[#c3e63c]"> - </span>
                <span className="text-white">Railway Machines</span>
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-neutral-400">
              Building an integrated platform of railway infrastructure machinery, robotics and AI — designed in India, engineered to global standards.
            </p>
            <div className="mt-6 inline-block bg-[#c3e63c] px-3 py-1.5 font-display font-bold uppercase tracking-[0.08em] text-[#0a0a0a] text-xs md:text-sm">Its a Garry Industries venture for railways projects!</div>
          </div>

          <div>
            <div className="eyebrow text-neutral-500 mb-5">Explore</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-neutral-300 hover:text-[#c3e63c] transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="eyebrow text-neutral-500 mb-5">Company</div>
            <ul className="space-y-3">
              {COMPANY_MENU.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-neutral-300 hover:text-[#c3e63c] transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="eyebrow text-neutral-500 mb-5">Get in touch</div>
            <a href={`mailto:${COMPANY.email}`} className="inline-flex items-center gap-2 text-sm text-white hover:text-[#c3e63c] transition-colors">
              <Mail size={15} /> {COMPANY.email}
            </a>
            <p className="mt-4 text-sm text-neutral-500">{COMPANY.location}</p>
            <Link to="/contact" className="mt-6 inline-flex btn-accent items-center gap-2 bg-[#c3e63c] px-5 py-2.5 eyebrow text-[#0a0a0a] hover:bg-[#d4f24d]">
              Start a conversation <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-white/10 pt-8">
          <div className="eyebrow text-neutral-600">© {new Date().getFullYear()} Garry Industries - Railway Machines</div>
          <div className="eyebrow text-neutral-600">Intelligent Railway Engineering · India</div>
        </div>
      </div>
    </footer>
  );
}
